import React from 'react';
import PropTypes from 'prop-types';

import SelectMenu from '../select';

const ProjectPreferences = ({ projects, setProjects, options, isLoading }) => {

	return (
		<SelectMenu
			data-testid="preferences-notifications-projects-select"
			classNamePrefix="btn-menu-react-select"
			placeholder="Type to search projects"
			options={options}
			value={projects}
			onChange={(selected) => setProjects(selected || [])}
			isLoading={isLoading}
			isMulti
		/>
	);
};

ProjectPreferences.propTypes = {
	projects: PropTypes.array.isRequired,
	options: PropTypes.array.isRequired,
	setProjects: PropTypes.func.isRequired,
	isLoading: PropTypes.bool
};

ProjectPreferences.defaultOptions = {
	isLoading: false
};

export default ProjectPreferences;
